export default __webpack_public_path__ + "static/sp-icon-ec3b404211624c559e94d447adea2b57.png";